var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.4167C0 8.67091 0 6.29803 0.938221 4.49188C1.72885 2.96985 2.96985 1.72885 4.49188 0.938221C6.29803 0 8.67091 0 13.4167 0H26.5833C31.3291 0 33.702 0 35.5081 0.938221C37.0301 1.72885 38.2711 2.96985 39.0618 4.49188C40 6.29803 40 8.67091 40 13.4167V26.5833C40 31.3291 40 33.702 39.0618 35.5081C38.2711 37.0301 37.0301 38.2711 35.5081 39.0618C33.702 40 31.3291 40 26.5833 40H13.4167C8.67091 40 6.29803 40 4.49188 39.0618C2.96985 38.2711 1.72885 37.0301 0.938221 35.5081C0 33.702 0 31.3291 0 26.5833V13.4167Z",
    fill: "#1265BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97817 12.4222C10.8946 12.4222 12.4482 10.8686 12.4482 8.95217C12.4482 7.03575 10.8946 5.48218 8.97817 5.48218C7.06175 5.48218 5.50818 7.03575 5.50818 8.95217C5.50818 10.8686 7.06175 12.4222 8.97817 12.4222Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6261 14.9866H21.377V17.6211C21.377 17.6211 22.9376 14.4999 27.1837 14.4999C30.9714 14.4999 34.1091 16.3659 34.1091 22.0533V34.0466H28.1496V23.5066C28.1496 20.1515 26.3584 19.7825 24.9935 19.7825C22.1608 19.7825 21.6758 22.2259 21.6758 23.9443V34.0466H15.6261V14.9866Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95329 14.9866H12.0031V34.0466H5.95329V14.9866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.21f96ac0e54ed777cf5f2d1a921602c7.svg";
export { ForwardRef as ReactComponent };